module.exports = __webpack_public_path__ + "static/section2_background-11b435b9511e3635b4448c8e44c66b95.png";